const en_master_storage = {
    '': "storage room",
    name: "storage name",
    add: "add storage",
    edit: "edit storage",
}

export default en_master_storage;